import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, Modal, Typography } from '@mui/material';

import {
  SUPPORT_EMAIL,
  SUPPORT_PHONE,
  SUPPORT_EMAIL_VK12,
  SUPPORT_EMAIL_CRIMSON,
} from '../../../../commonUtils/constants';
import { pxToRem, pxTovW } from '../../../../commonUtils/resizeUtils';
import { IStyles } from '../../../../commonUtils/styleUtils';
import {
  copyToClipboard,
  isCrimson,
  isVK12,
} from '../../../../commonUtils/utilFunctions';
import ImageWrapper from '../../../elements/ImageWrapper';

const styles: IStyles = {
  modal: {
    boxSizing: 'border-box',
    display: { xs: 'flex' },
    alignItems: 'flex-end',
  },

  root: {
    backgroundColor: 'common.white',
    // background: 'red',
    margin: 'auto',
    width: { xs: '80%', md: '35%', lg: pxTovW(467) },
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    '&:focus-visible': {
      outline: 'none',
    },
    position: 'relative',
  },
  contactRow: {
    marginTop: {
      xs: pxToRem(-45),
      lg: pxTovW(-45),
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  contactWrapper: {
    backgroundColor: 'common.white',
    display: 'inline-block',
    padding: {
      xs: pxToRem(24),
      lg: pxTovW(24),
    },
    borderRadius: '50%',
  },
  contact: {
    height: {
      xs: pxToRem(66),
      lg: pxTovW(66),
    },
    width: {
      xs: pxToRem(66),
      lg: pxTovW(66),
    },
  },
  textStyles: {
    px: {
      xs: pxToRem(40),
      lg: pxTovW(40),
    },
    pb: {
      xs: pxToRem(40),
      lg: pxTovW(40),
    },
    textAlign: 'center',
  },
  callBox: {
    py: {
      xs: pxToRem(20),
      lg: pxTovW(20),
    },
    mb: {
      xs: pxToRem(20),
      lg: pxTovW(20),
    },
    borderBottom: '1px solid #D2D2D2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: {
      xs: pxToRem(10),
      lg: pxTovW(10),
    },
  },
  emailBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: {
      xs: pxToRem(10),
      lg: pxTovW(10),
    },
  },
  copy: {
    fontSize: '16px',
    color: '#0AA34F',
    cursor: 'pointer',
  },
};

//* Interface
interface IProps {
  open: boolean;
  setOpen: (arg: boolean) => void;
  schoolId?: string | number;
}
export const ContactPopup = ({ open, setOpen, schoolId }: IProps) => {
  let FINAL_SUPPORT_EMAIL = SUPPORT_EMAIL;
  if (schoolId && isVK12(schoolId)) FINAL_SUPPORT_EMAIL = SUPPORT_EMAIL_VK12;
  if (schoolId && isCrimson(schoolId))
    FINAL_SUPPORT_EMAIL = SUPPORT_EMAIL_CRIMSON;

  return (
    <Modal open={open} onClose={() => setOpen(false)} sx={styles.modal}>
      <Box sx={styles.root}>
        <CloseIcon
          sx={{
            color: 'common.black',
            fontSize: { xs: pxToRem(14), lg: pxTovW(18) },
            right: { xs: pxToRem(10), md: pxTovW(10) },
            top: { xs: pxToRem(10), md: pxTovW(10) },
            position: 'absolute',
            cursor: 'pointer',
          }}
          onClick={(ev) => {
            setOpen(false);
          }}
        />
        <Box sx={styles.contactRow}>
          <Box sx={styles.contactWrapper}>
            <ImageWrapper
              name="contact-popup"
              type="png"
              parentFolder="icons"
              styles={styles.contact}
            />
          </Box>
        </Box>
        <Box sx={styles.textStyles}>
          <Box>
            <Typography variant="h1">Contact us</Typography>
            {schoolId && !(isCrimson(schoolId) || isVK12(schoolId)) ? (
              <Box sx={styles.callBox}>
                <Typography variant={'bodyText'}>
                  Call:{' '}
                  <Box
                    sx={{ color: 'inherit', textDecoration: 'inherit' }}
                    component="a"
                    href={`tel:${SUPPORT_PHONE}`}
                  >
                    {SUPPORT_PHONE}
                  </Box>{' '}
                </Typography>
                <ContentCopyIcon
                  sx={styles.copy}
                  onClick={() => copyToClipboard(SUPPORT_PHONE)}
                />
              </Box>
            ) : null}

            <Box sx={styles.emailBox}>
              <Typography variant="bodyText">
                <Box
                  sx={{ color: 'inherit', textDecoration: 'inherit' }}
                  component="a"
                  href={`mailto:${FINAL_SUPPORT_EMAIL}`}
                >
                  Email: {FINAL_SUPPORT_EMAIL}
                </Box>{' '}
              </Typography>
              <ContentCopyIcon
                sx={styles.copy}
                onClick={() => copyToClipboard(FINAL_SUPPORT_EMAIL)}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
